import { Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import { TransactionAccount } from '@css-xp/graphtypes/src/generated-types-new';
import React from 'react';
import { BillingAccountTable } from './progress-forms/billing-account-table';
import { FormData } from './subscription-txa-transfer-pane';

type Props = {
  formState: FormData;
  selectBillingAccount: (billingAccount: TransactionAccount) => void;
  transactionAccountNumber: String | undefined | null;
};

export const SearchPage = ({ formState, selectBillingAccount, transactionAccountNumber }: Props) => {
  return (
    <div className="plan-view">
      <h2>Select another billing account</h2>
      <Field name="searchQuery" label="Search for billing account" isRequired defaultValue={formState.searchQuery}>
        {({ fieldProps }) => (
          <TextField
            autoFocus
            testId="search-form"
            placeholder="Company name/email/billing account ID"
            {...fieldProps}
          />
        )}
      </Field>
      <div className="billing-account-wrapper">
        <BillingAccountTable
          transactionAccountNumber={transactionAccountNumber}
          formState={formState}
          selectBillingAccount={selectBillingAccount}
        />
      </div>
    </div>
  );
};

export default SearchPage;
